module.exports = __webpack_public_path__ + "static/media/udv.b5e8d8a2.png";